import React from 'react'
import SuccessStoryIcon from 'assets/images/funds/successStory.svg'

export default function SuccessStory() {
    return (
        <div className="my-[6px] flex items-center gap-3 bg-[#E6F3DD] rounded-[10px] p-4">
            <img
                src={SuccessStoryIcon}
                alt="success-story"
                className="h-[65px] w-auto shrink-0 object-contain"
            />
            <div className="flex-1 min-w-0">
                <p className="text-base font-bold text-heading text-right truncate">
                    داستان موفقیت صندوق ها
                </p>
                <p className="text-sm font-normal text-[#888888] text-right truncate">
                    مدیریت صندوق به سبک حرفه ای ها
                </p>
                <div className="flex justify-end mt-2">
                    <button className="bg-white rounded-full px-4 pt-1 pb-[2px] text-xs font-normal text-black">
                        بزودی
                    </button>
                </div>
            </div>
        </div>
    )
}
